
const dataLayerEvents = {
  page_type: null,
  init() {
    window.dataLayer = window.dataLayer || [];
  
    // Events
    this.preheader_local_website()
    this.mailto()
    this.search()
    this.product_page_form()
    this.solution_page_form()
    this.file_add_to_cart()
    this.single_download()
    this.batch_download()
    this.contact_initation()
    this.job_offer_clic()
    this.contact_form()
  },
  preheader_local_website() {
    $('.nav-site-selector').on('click', '.nav-sub-link', function() {
      window.dataLayer.push({
        'page_type': window.page_type,
        'event': 'preheader_local_website',
        'button_name': $(this).text(),
        'button_label': $(this).parents('.country-name-item').find('> .nav-link').text(),
        'local_website_button': '',
      })
    })
  },

  mailto() {
    $('a[href^="mailto:"]').click(function () {
      window.dataLayer.push({
        'event': 'mailto',
        'page_type': window.page_type,
        'email': $(this).attr('href').replace('mailto:', ''),
      })
    })
  },

  search() {
    $('.search-form').submit(function() {
      window.dataLayer.push({
        'event': 'search',
        'page_type': window.page_type,
        'keywords': $(this).find('input[name="s"]').val(),
      })
    })

    $(document).on('click', '.relevanssi-live-search-result a', function() {
      window.dataLayer.push({
        'event': 'search',
        'page_type': window.page_type,
        'keywords': $('.search-dropdown').find('input[name="s"]').val(),
        'suggested_element_name': $(this).text().replace(/[+*\n]|^\d+/g, '').replace(/\s+/g, ' ').trim(),
        'suggested_element_category': $(this).parents('.relevanssi-live-search-result').find('.badge').text(),
      })
    });
  },

  product_page_form() {
    if (window.page_type !== 'product_page') return false

    $('form[id^="gform"]').submit(function() {
      let category = [];
      $('a[data-type="category"]').each(function() {
        category.push($(this).text())
      })

      window.dataLayer.push({
        'event': 'product_page_form',
        'page_type': window.page_type,
        'category': category.length > 0 ? category[0] : null,
        'application': category.length >= 2 ? category[1] : null,
        'family': category.length >= 3 ? category[2] : null,
        // 'category': category.join(' / '),
        'product_name': $('h1').text(),
        'solution': $('a[data-type="solution"]').text(),
      })
    })
  },

  solution_page_form() {
    if (window.page_type !== 'solution_page') return false

    window.addEventListener('message', (event) => {
      if (event.data && event.data.eventName && event.data.eventName == 'onFormSubmitted') {
        let category = [];
        $('a[data-type="category"]').each(function() {
          category.push($(this).text())
        })
  
        window.dataLayer.push({
          'event': 'solution_page_form',
          'page_type': window.page_type,
          // 'category': category.join(' / '),
          'category': category.length > 0 ? category[0] : null,
          'application': category.length >= 2 ? category[1] : null,
          'family': category.length >= 3 ? category[2] : null,
          'solution': $('h1').text(),
        })
      }
    })
  },

  file_add_to_cart() {
    $('.btn-add-download-cart').click(function() {
      let category = [];
      $('a[data-type="category"]').each(function() {
        category.push($(this).text())
      })

      window.dataLayer.push({
        'event': 'file_add_to_cart',
        'page_type': window.page_type,
        'file_name': $(this).data('filename'),
        'file_extension': $(this).data('fileextension'),
        'file_type': $(this).data('filetype'),
        'category': category.length > 0 ? category[0] : null,
        'application': category.length >= 2 ? category[1] : null,
        'family': category.length >= 3 ? category[2] : null,
        'product_name': $('h1').text(),
        'solution': $('a[data-type="solution"]').text(),
      })
    })
  },
  single_download() {
    $('.document-link').click(function() {
      let category = [];
      $('a[data-type="category"]').each(function() {
        category.push($(this).text())
      })

      window.dataLayer.push({
        'event': 'single_download',
        'page_type': window.page_type,
        'file_name': $(this).data('filename'),
        'file_extension': $(this).data('fileextension'),
        'file_type': $(this).data('filetype'),
        'category': category.length > 0 ? category[0] : null,
        'application': category.length >= 2 ? category[1] : null,
        'family': category.length >= 3 ? category[2] : null,
        // 'category': category.join(' / '),
        'product_name': $('h1').text(),
        'solution': $('a[data-type="solution"]').text(),
      })
    })
  },
  batch_download() {
    $('#cart-results').on('click', '.btn-download-all-cart', function() {
      let files = [];
      $('.cart-list .cart-item').each(function() {
        files.push({
          'file_type': $(this).find('.link').data('filetype'),
          'file_extension': $(this).find('.link').data('fileextension'),
          'file_name': $(this).find('.link').data('filename'),
        });
      });

      window.dataLayer.push({
        'event': 'batch_download',
        'page_type': window.page_type,
        'files': files,
      })
    })
  },
  contact_initation() {
    if (window.page_type === 'category_page') {
      $('a[data-expert]').click(function() {
        window.dataLayer.push({
          'event': 'contact_initation',
          'page_type': window.page_type,
          'category': $('h1').text(),
          'button_label': $(this).text(),
          'button_name': $(this).data('name'),
        })
      })

      $('#navbarContainer').on('click', 'a.btn[href*="contact"]', function() {
        window.dataLayer.push({
          'event': 'contact_initation',
          'page_type': window.page_type,
          'category': $('h1').text(),
          'button_label': $(this).text(),
          'button_name': 'Header CTA',
        })
      })
    } else if (window.page_type === 'product_page') {
      $('#navbarContainer').on('click', 'a.btn[href*="contact"]', function() {
        let category = [];
        $('a[data-type="category"]').each(function() {
          category.push($(this).text())
        })

        window.dataLayer.push({
          'event': 'contact_initation',
          'page_type': window.page_type,
          'category': category.length > 0 ? category[0] : null,
          'application': category.length >= 2 ? category[1] : null,
          'family': category.length >= 3 ? category[2] : null,
          'solution':  $('a[data-type="solution"]').text(),
          'button_label': $(this).text(),
          'button_name': 'Header CTA',
        })
      })
    } else {
      $('#navbarContainer').on('click', 'a.btn[href*="contact"]', function() {
        window.dataLayer.push({
          'event': 'contact_initation',
          'page_type': window.page_type,
          'button_label': $(this).text(),
          'button_name': 'Header CTA',
        })
      })
    }
  },
  job_offer_clic() { 
    $('.job-offer-item').on('click', 'a.ghost-link', function() {
      window.dataLayer.push({
        'event': 'job_offer_clic',
        'page_type': window.page_type,
        'button_label': $(this).text().replace(/[+*\n]|^\d+/g, '').replace(/\s+/g, ' ').trim(),
        'button_name': 'Job offer button',
      })
    })
  },

  contact_form() {
    if (window.page_type !== 'solution_page') {
      window.addEventListener('message', (event) => {
        if (event.data && event.data.eventName && event.data.eventName == 'onFormSubmitted') {
          window.dataLayer.push({
            'event': 'contact_form',
            'page_type': window.page_type,
          })
        }
      });
    }

  },
}

export default dataLayerEvents


// WEBPACK FOOTER //
// ./scripts/includes/dataLayerEvents.js